import { Component, input, output } from '@angular/core'

import type { ArticleCategory } from '../../../../api/responses'
import type { ArticleWithNullableRefs } from '../../../../types/types'
import { ArticleCategoryButton } from './article-category-button'

@Component({
  standalone: true,
  selector: 'dhp-article-category-list',
  templateUrl: './article-category-list.html',
  imports: [ArticleCategoryButton],
})
export class ArticleCategoryList {
  public readonly article = input.required<ArticleWithNullableRefs>()

  protected readonly categoryArticle = output<{
    article: ArticleWithNullableRefs
    category: ArticleCategory
  }>()
}
